import { memo } from 'react';

function NotificationsBellIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill="#F4F6F8"
        d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20"
      ></path>
      <path
        stroke="#212B36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M26 16.4c0-1.697-.632-3.325-1.757-4.525S21.59 10 20 10s-3.117.674-4.243 1.874C14.632 13.074 14 14.704 14 16.4c0 7.467-3 9.6-3 9.6h18s-3-2.133-3-9.6M21.73 29a2 2 0 0 1-3.46 0"
      ></path>
    </svg>
  );
}

export default memo(NotificationsBellIcon);
